// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2ZeG5","center":"Table_center__2kfff","right":"Table_right__EJGS5","fill":"Table_fill__3z7D7","footerHeader":"Table_footerHeader__13yZl"};